// 集計タブのラベルと対応するgroup_by値
export const tabLabels = ['荷主別', '運送会社別', '車両別', 'ドライバー別'];
export const tabTypes = ['shipper', 'carrier', 'truck', 'driver'] as const;

export type GroupByType = typeof tabTypes[number];

// 期間モード
export const PERIOD_MODES = ['daily', 'monthly'] as const;
export type PeriodMode = typeof PERIOD_MODES[number];
